import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
  cilCircle,
  cilDoor,
  cilList,
  cilHome,
  cilNewspaper,
  cilBolt,
  cilFeaturedPlaylist,
  cilDollar,
  cilPeople,
  cilChatBubble,
  cilHighligt,
  cilStorage,
  cilFridge,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'

// 메뉴설정
// 1. _navCus.js 에서 items 하위 to, name 설정
// 2. route.js 에서 path, name 설정 (1번의 to, name 과 동일)
// 3. route.js 에서 element 설정
const _nav = [
  {
    component: CNavItem,
    name: '대쉬보드',
    to: '/dashboardCube',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    className: 'small',
  },
  {
    component: CNavTitle,
    name: '서비스',
  },
  {
    component: CNavGroup,
    name: '이용내역',
    to: '/service',
    icon: <CIcon icon={cilFeaturedPlaylist} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '센터도어 로그',
        to: '/service/centerAccessLogList',
      },
      {
        component: CNavItem,
        name: '매출내역',
        to: '/service/orderList',
      },
      {
        component: CNavItem,
        name: '예약내역',
        to: '/service/spaceUseList',
      },
      {
        component: CNavItem,
        name: '주문메모',
        to: '/service/orderCommentList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '대출현황',
    to: '/pwan',
    icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '대출내역',
        to: '/pwan/orderGoodsPwanDetailsList',
      },
      {
        component: CNavItem,
        name: '매입내역',
        to: '/pwan/orderGoodsPwanSellDetailsList',
      },
      {
        component: CNavItem,
        name: '이자상환내역',
        to: '/pwan/orderGoodsPwanDetailsBackList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '문자',
    to: '/send',
    icon: <CIcon icon={cilChatBubble} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '문자발송',
        to: '/send/sendList',
      },
      {
        component: CNavItem,
        name: '문자발송통계',
        to: '/send/sendReceiveStat',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'AI',
    to: '/ai',
    icon: <CIcon icon={cilHighligt} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '상품별 예상주문건수',
        to: '/goods/goodsListPredictOrderCnt',
        badge: {
          color: 'danger-gradient',
          text: 'AI',
        },
      },
    ],
  },

  // {
  //   component: CNavTitle,
  //   name: '매출관리',
  // },
  // {
  //   component: CNavGroup,
  //   name: '당일매출',
  //   to: '/goods',
  //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //   className: 'small',
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: '매출요약',
  //       to: '/goods/goodsList',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '매출상세내역',
  //       to: '/goods/goodsUpload',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '매출취소내역',
  //       to: '/goods/goodsList',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '메뉴별내역',
  //       to: '/goods/goodsList',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '분류별내역',
  //       to: '/goods/goodsList',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: '기간별 매출현황',
  //   to: '/order',
  //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //   className: 'small',
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: '일별현황',
  //       to: '/order/orderStat',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '월별현황',
  //       to: '/order/orderStat',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '시간대별현황',
  //       to: '/order/orderStat',
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: '유형별 매출현황',
  //   to: '/order',
  //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //   className: 'small',
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: '카테고리별',
  //       to: '/order/orderStat',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '상품별',
  //       to: '/order/orderStat',
  //     },
  //   ],
  // },
  {
    component: CNavTitle,
    name: '설정',
  },
  {
    component: CNavGroup,
    name: '센터',
    to: '/center',
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '센터 관리',
        to: '/center/centerList',
      },
      {
        component: CNavItem,
        name: '센터 관제일지',
        to: '/center/centerRecordList',
      },
      {
        component: CNavItem,
        name: '공지사항',
        to: '/center/noticeList',
      },
      {
        component: CNavItem,
        name: '센터약관 관리',
        to: '/center/centerRuleList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '센터도어',
    to: '/centerDoor',
    icon: <CIcon icon={cilDoor} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '센터도어 관리',
        to: '/centerDoor/centerDoorList',
      },
      // {
      //   component: CNavItem,
      //   name: '센터도어키',
      //   to: '/centerDoor/centerDoorCodeList',
      // },
      {
        component: CNavItem,
        name: '센터도어 스케쥴',
        to: '/centerDoor/centerDoorScheduleList',
      },
      {
        component: CNavItem,
        name: '센터도어 스케쥴 요청',
        to: '/centerDoor/centerDoorScheduleRequestList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '센터장비',
    to: '/centerMachine',
    icon: <CIcon icon={cilFridge} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '센터장비상세 관리',
        to: '/centerMachine/centerMachineDetailsList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '사용자',
    to: '/user',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '관리자 관리',
        to: '/user/adminList',
      },
      {
        component: CNavItem,
        name: '사용자 관리',
        to: '/user/userList',
      },
      {
        component: CNavItem,
        name: '사용자 메모',
        to: '/user/userAuthMemoList',
      },
      {
        component: CNavItem,
        name: '블랙리스트 관리',
        to: '/user/userBlacklistList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '상품',
    to: '/goods',
    icon: <CIcon icon={cilNewspaper} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '상품 관리',
        to: '/goods/goodsList',
      },
      {
        component: CNavItem,
        name: '상품 엑셀 등록',
        to: '/goods/goodsUpload',
        badge: {
          color: 'info-gradient',
          text: '엑셀',
        },
      },
      {
        component: CNavItem,
        name: '상품유형 관리',
        to: '/goods/goodsTypeList',
      },
      {
        component: CNavItem,
        name: '상품유형 엑셀 등록',
        to: '/goods/goodsTypeUpload',
        badge: {
          color: 'info-gradient',
          text: '엑셀',
        },
      },
      {
        component: CNavItem,
        name: '카테고리 관리',
        to: '/goods/goodsCateList',
      },
      {
        component: CNavItem,
        name: '카테고리 엑셀 등록',
        to: '/goods/goodsCateUpload',
        badge: {
          color: 'info-gradient',
          text: '엑셀',
        },
      },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: '상품옵션',
  //   to: '/goods',
  //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: '상품옵션 관리',
  //       to: '/goods/goodsList',
  //     },
  //     {
  //       component: CNavItem,
  //       name: '상품옵션 엑셀 등록',
  //       to: '/goods/goodsUpload',
  //     },
  //   ],
  // },
  {
    component: CNavGroup,
    name: '재고',
    to: '/goodsInvenHist',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '재고 관리',
        to: '/goodsInvenHist/goodsInvenHistGoodsList',
      },
      {
        component: CNavItem,
        name: '재고 엑셀 등록',
        to: '/goodsInvenHist/goodsInvenHistUpload',
        badge: {
          color: 'info-gradient',
          text: '엑셀',
        },
      },
      {
        component: CNavItem,
        name: '상품 입출고 이력',
        to: '/goodsInvenHist/goodsInvenHistList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '데이타',
    to: '/data',
    icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '시세 관리',
        to: '/data/dataMarketList',
      },
    ],
  },
  {
    component: CNavGroup,
    name: '로그',
    to: '/log',
    icon: <CIcon icon={cilList} customClassName="nav-icon" />,
    className: 'small',
    items: [
      {
        component: CNavItem,
        name: '관리자변경 로그',
        to: '/log/adminLogList',
      },
    ],
  },
]

export default _nav
